module.exports = __webpack_public_path__ + "img/hakuna_bg04_sub.03c7011a.png";